__turbopack_context__.v({
  "asset": "UpcomingIntegrations-module__wjm4Oa__asset",
  "assetImage": "UpcomingIntegrations-module__wjm4Oa__assetImage",
  "card": "UpcomingIntegrations-module__wjm4Oa__card",
  "cardSubtitle": "UpcomingIntegrations-module__wjm4Oa__cardSubtitle",
  "cardTitle": "UpcomingIntegrations-module__wjm4Oa__cardTitle",
  "grid": "UpcomingIntegrations-module__wjm4Oa__grid",
  "heading": "UpcomingIntegrations-module__wjm4Oa__heading",
  "section": "UpcomingIntegrations-module__wjm4Oa__section",
  "text": "UpcomingIntegrations-module__wjm4Oa__text",
});
